module.exports = __webpack_public_path__ + "img/schedule_nodata.e4a8cfce.png";